import React from "react";
import { Modal } from "react-bootstrap";
import RestlessDisplayProperty from "../../../components/common/RestlessDisplayProperty";

export default function UserDetailsDialogForm({
  actionsLoading,
  user,
  onHide,
  userInformation,
  userInformationLoading,
}) {
  return (
    <>
      <Modal.Body className="overlay overlay-block cursor-default">
        {actionsLoading || userInformationLoading ? (
          <div className="overlay-layer bg-transparent">
            <div className="spinner spinner-lg spinner-success" />
          </div>
        ) : (
          <div className="container ">
            <div className="row mb-4">
              <div className="col">
                <RestlessDisplayProperty
                  label="Name"
                  content={user?.full_name}
                />
              </div>
            </div>
            <div className="row mb-4">
              <div className="col">
                <RestlessDisplayProperty label="Role" content={user?.status} />
              </div>
              <div className="col">
                <RestlessDisplayProperty label="Email" content={user?.email} />
              </div>
            </div>
            <hr />
            <div className="col">
              <div className="row mb-4">
                <strong>Connections</strong>
              </div>
              <div className="row mb-4">
                <div className="col">
                  <RestlessDisplayProperty
                    label="Friends"
                    content={userInformation?.friends}
                  />
                </div>
                <div className="col">
                  <RestlessDisplayProperty
                    label="Following"
                    content={userInformation?.follows}
                  />
                </div>
                <div className="col">
                  <RestlessDisplayProperty
                    label="Ignoring"
                    content={userInformation?.mutes}
                  />
                </div>
                <div className="col">
                  <RestlessDisplayProperty
                    label="Blocking"
                    content={userInformation?.blocks}
                  />
                </div>
              </div>
            </div>
            <hr />
            <div className="col mb-4 ">
              <div className="row mb-4">
                <strong>Interactions</strong>
              </div>
              <div className="row mb-4">
                <div className="col">
                  <RestlessDisplayProperty
                    className="h6"
                    label="Posts"
                    content={userInformation?.posts}
                  />
                </div>
                <div className="col">
                  <RestlessDisplayProperty
                    label="Comments"
                    content={userInformation?.comments}
                  />
                </div>
                <div className="col">
                  <RestlessDisplayProperty
                    label="Hashtags Followed"
                    content={userInformation?.hash_tags || 0}
                  />
                </div>
                <div className="col">
                  <RestlessDisplayProperty
                    className="text-nowrap"
                    label="Categories Followed"
                    content={userInformation?.categories || 0}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          onClick={onHide}
          className="btn btn-light btn-elevate"
        >
          Cancel
        </button>
      </Modal.Footer>
    </>
  );
}
